// extracted by mini-css-extract-plugin
export var section = "ContentCards2-module--section--1402d";